import { gql } from "@apollo/client";
import { useState } from "react";
import { useQuery } from "@apollo/client";

const GET_ACCOUNT_CONTACTS = gql`
  query getAccountContacts($accountId: ID!) {
    account {
      id
      contacts(accountId: $accountId) {
        id
        name
        email
      }
    }
  }
`;

const PAGE_SIZE = 100;

export const useContacts = accountId => {
  const [isInitialFetch, setIsInitialFetch] = useState(true);
  const [limit, setLimit] = useState(PAGE_SIZE);
  const [offset, setOffset] = useState(0);

  const { loading, data, error, fetchMore } = useQuery(GET_ACCOUNT_CONTACTS, {
    variables: { accountId },
    fetchPolicy: isInitialFetch ? "network-only" : "cache-first",
    notifyOnNetworkStatusChange: true,
    onError: error => {
      throw error;
    }
  });

  const contacts = data?.account?.contacts ?? [];
  const totalResults = contacts.length;

  const loadMore = () => {
    if (contacts.length < totalResults) {
      setIsInitialFetch(false);
      const newOffset = offset + limit;
      setOffset(newOffset);

      fetchMore({
        variables: {
          accountId,
          offset: newOffset,
          limit: PAGE_SIZE
        },
        fetchPolicy: "network-only"
      }).then(({ data }) => {
        setLimit(limit + data.account.contacts.length);
      });
    }
  };

  return {
    loading: isInitialFetch && loading,
    loadingMore: !isInitialFetch && loading,
    contacts,
    hasMore: contacts.length < totalResults,
    loadMore,
    error
  };
};
